export default __webpack_public_path__ + "static/media/image01.ba6cbb3b.png";